import { useFormik } from "formik";
import { useTranslation } from "react-i18next";
import * as yup from "yup";
import { PAGE_LOGIN } from "../../locales/pages/namespaces";
import useUserAction from "../user/useUserAction";


const useLogin = ({campaign}) => {
	const { t } = useTranslation(PAGE_LOGIN)
	const { userLogin } = useUserAction()

	const onSubmit = (values) => {
		userLogin({
			...values,
			campaign,
		});
	};

	const validationSchema = yup.object({
		email: yup
		.string()
		.email(t('Invalid email'))
		.required(t('Required')),
		password: yup
		.string()
		.required(t('Required'))
	})
	
	const formik = useFormik({
		initialValues: {
			email: '',
			password: '',
		},
		validationSchema: validationSchema,
		onSubmit: onSubmit,
	})
	
	return {
		formik
	}
}

export default useLogin